import React from "react";

import { Flex, FlexItem, FlexBlock } from "@wordpress/components";

const InvoicesList = (props) => {
  const invoiceItemBackColor = "#f5f6f9";
  return (
    <>
      <Flex className="section-title">
        {props.invoices.length ? "Your" : "No"} invoices
      </Flex>
      <div
        style={{
          width: "calc(100% - 20px)",
          paddingLeft: "10px",
          paddingRight: "10px",
          marginLeft: "0",
          borderRadius: "2px",
          backgroundColor: "#f5f6f9",
        }}
      >
        {/* No invoices item */}
        {!props.invoices.length && (
          <Flex className="section-row">Your invoices will appear here.</Flex>
        )}

        {/* TODO andy */}
        {/* invoice.hosted_invoice_url or invoice.invoice_pdf */}
        {/* Invoices items */}
        {props.invoices.map((item, index) => (
          <Flex key={index} className="section-row invoice-row">
            <FlexItem>
              <u>Invoice #{item.number + " - " + item.paid_at_date}</u>
            </FlexItem>
            <FlexItem>
              {item.amount_paid ? "$" + item.amount_paid / 100 : ""}{" "}
            </FlexItem>
          </Flex>
        ))}

        {/* Total item */}
        {props.invoices.length > 0 && (
          <Flex className="section-row invoice-row" style={{ border: "none" }}>
            <FlexItem>
              <b>Total</b>
            </FlexItem>
            <FlexItem>
              <b>
                $
                {props.invoices
                  .map((item) => item.amount_paid / 100)
                  .reduce((sum, current) => sum + current, 0)
                  .toFixed(2)}
              </b>
            </FlexItem>
          </Flex>
        )}
      </div>
    </>
  );
};

export default InvoicesList;
